// eslint-disable-next-line import/no-cycle
import { RadioOption } from "../scripts/components/RadioList";

export enum DrugTestType {
  FIVE_PANEL = 2,
  FIVE_PANEL_NO_THC = 1,
  TEN_PANEL = 4,
}

export const drugTestOptions: Array<RadioOption> = [
  {
    label: "5-panel (no THC)",
    text: "5-panel drug test excluding THC",
    value: DrugTestType.FIVE_PANEL_NO_THC,
  },
  {
    label: "5-panel",
    text: "Standard 5-panel drug test (includes THC)",
    value: DrugTestType.FIVE_PANEL,
  },
  {
    label: "10-panel",
    text: "Comprehensive 10-panel drug test",
    value: DrugTestType.TEN_PANEL,
  },
];

export const DRUG_TEST_MESSAGES = {
  STATE_EXEMPT: (state: string) => `Drug testing not required in ${state} per state regulations`,
  FIELD_LABEL: "Drug Testing Requirements",
};
